import { Injectable } from '@angular/core';
import { getCookie, setCookie } from './cookie';

@Injectable()
export class IAMTokenService {
  iamToken = '';

  constructor() {
    this.setIAMToken(getCookie('iam_token'));
  }

  getIAMToken(): string {
    return this.iamToken;
  }

  setIAMToken(value: string): void {
    setCookie('iam_token', value);
    this.iamToken = value;
  }
}
